<template>
  <Transition name="fade">
    <div class="floating-label" :style="style">
      {{ text }}
    </div>
  </Transition>
</template>

<script>
import store from '../store/store';

export default {
  name: 'FloatingLabel',
  props: {
    'text': {
      type: String,
      required: true
    }
  },
  computed: {
    style() {
        const isHeaderHidden = store.getters.HideHeaderBar();
        if (isHeaderHidden) {
            return 'top: 15px';
        } else {
            return 'top: 67px'
        }
    }
  }
}
</script>

<style scoped>
.floating-label {
  padding: 5px 10px;
  border-radius: 2rem;
  background-color: #007bff;
  color: white;
  position: fixed;
  right: 15px;
  z-index: 100;
}

.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-leave-to {
  opacity: 0;
}
</style>